import type { ReactNode } from 'react';

import { cn } from '../../ui/utils';

export function Page(props: { width?: 'default' | 'narrow'; children: ReactNode }): ReactNode {
  return (
    <div
      className={cn('flex w-full flex-col gap-8', props.width === 'narrow' && 'mx-auto max-w-3xl')}
    >
      {props.children}
    </div>
  );
}
